import { Card, CardBody, CardHeader, Col, Label, Row, Table } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { H4 } from "../../../AbstractElements";
import { useEffect, useState } from "react";
import { AesDecrypt, AesEncrypt, keyPromise } from "../../../Service/crypto";
import webservice from '../../../Service/webservice';
import websocket_webservice from "../../../Service/websocket_webservice";
import Select from 'react-select';
import { RootState } from "../../../ReaduxToolkit/Store";
import { useSelector } from "react-redux";
import ColumnChooser, { ColumnOption, isColVisible, visibleColCount } from "../../../Components/ColumnChooser/ColumnChooser";
import { useColumnPreferences } from "../../../hooks/useColumnPreferences";
import api from '../../../api';

interface ClientOption {
  label: string;
  value: string;
  key: string;
}

const RecentOrders = () => {

  const [adminoption, setClient] = useState<ClientOption[]>([]);
  const [recentOrdersBody, setrecentOrdersBody] = useState<[]>([]);
  const [ClientName, setClientName] = useState<string>('All');
  const [ClientId, setClientId] = useState<string>('ALL');
  const [formatDate, setFormatdate] = useState<string>('');
  const { savedColumns, saveColumns } = useColumnPreferences('ClientwiseErrorListing');
  const columnOptions: ColumnOption[] = [
    { id: 'ClientName', label: 'Client Name', locked: true },
    { id: 'PatientName', label: 'Patient Name' },
    { id: 'Payer', label: 'Payer' },
    { id: 'Date', label: 'Date' },
    { id: 'Errors', label: 'Errors' },
  ];

  // Access the selected bar date from Redux store
  const selectedBarDate = useSelector(
    (state: RootState) => state.selectedDate.selectedBarDate
  );

  useEffect(() => {

    if (selectedBarDate) {
      // Convert MM/DD/YYYY to YYYY-MM-DD
      const [month, day, year] = selectedBarDate.split("/");
      const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      setFormatdate(formattedDate)
      // Use formattedDate for fetching or filtering data if needed.
    }
  }, [selectedBarDate]);


  const ViewAuditLog = async () => {
    const Username = localStorage.UserName;
    const Userid = localStorage.id;
    const Clientname = ClientName;
    const Chartname = 'Error Chart'
    const Data = { Username, Clientname, Userid, Chartname };

    const key = await keyPromise
    const EncParams = await AesEncrypt(key,Data);
    const response = await api.fetch('api/Dashboard/auditlog', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    return response;
  };


  useEffect(() => {
    const fetchRole = async (Ids: any, date: string, adminoption: any) => {
      const UserType = localStorage.UserType;
      let Id
      if (localStorage.UserType === 'MOS') {
        Id = Ids;
      }
      else if (UserType === 'Vendor') {
        if (Ids === 'ALL') {
          const allClient: any = adminoption.filter((option: any) => option.value !== 'ALL').map((option: any) => option.value);
          Id = allClient;
        } else {
          Id = Ids;
        }
      } else {
        Id = localStorage.ClientId;
      }
      const key = await keyPromise
      const EncParams = await AesEncrypt(key,{ Id, date, UserType });
      const response = await api.fetch('api/Dashboard/ClientwiseError', {
        method: 'POST',
        body: JSON.stringify({ EncParams }),
      }).then((response) => response.json());
      const TempData = await AesDecrypt(key,response);

      setrecentOrdersBody(TempData);
      return TempData;
    };
    if (adminoption.length !== 0) {

      fetchRole(ClientId, formatDate, adminoption);
    }
    ViewAuditLog();

    // const socket = new WebSocket(`${websocket_webservice}ws/Dashboardpatient/`);

    // socket.onmessage = () => {
    //   fetchRole(ClientId, formatDate, adminoption);
    // };

    // return () => {
    //   if (socket.readyState === 1) {
    //     socket.close();
    //   }
    // };
  }, [ClientId, formatDate, adminoption]);


  const get_ClientRoleId = async () => {
    const UserType = localStorage.UserType;
    const key = await keyPromise
    const Id = localStorage.VendorId;
    let bodyData = {};
    if (UserType === 'MOS') {
      bodyData = { UserType }; // Send UserType only
    } else if (UserType === 'Vendor') {
      bodyData = { UserType, VendorId: Id }; // Send both UserType and VendorId
    }
    const response = await api.fetch('api/Dashboard/getclient', {
      method: 'POST',
      body: JSON.stringify(bodyData), // Send the request body
    }).then((response) => response.json());

    const TempData = await AesDecrypt(key,response);
    return TempData;
  };

  useEffect(() => {
    const fetchRoleId = async () => {
      const response = await get_ClientRoleId();
      const res = response.map((data: any) => ({
        label: data.CompanyName,
        value: data.id,
        key: data.id,

      }));
      const allOption: ClientOption = {
        label: "All",
        value: "ALL",
        key: '',
      };
      setClient([allOption, ...res]);

    };

    fetchRoleId();
  }, []);

  const handleClientChange = async (selectedOption: any) => {
    if (selectedOption) {
      if (localStorage.Usertype === 'Vendor' && selectedOption.value === 'ALL') {
        const allClient: any = adminoption.filter(option => option.value !== 'ALL').map((option) => option.value);
        setClientId(allClient)
      } else {
        setClientId(selectedOption.value);
      }
      setClientName(selectedOption.label);
      setFormatdate('')
    } else {
      setClientName('');

      setClientId('ALL');

    }
  }

  return (

    <Card className="invoice-card" style={{ height: '93%' }}>
      <CardHeader className="pb-0">
        <Row>
          <Col xl={6}>
            <div className="header-top">
              <H3 className="m-0">
                Error Log
              </H3>
              <div className="me-2">
                <ColumnChooser options={columnOptions} savedColumns={savedColumns} onChange={saveColumns} />
              </div>
            </div>
          </Col>
          {(localStorage.UserType === 'MOS' || localStorage.UserType === 'Vendor') && (
            <Col xl={6}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <Label check className="form-label" style={{ fontSize: "110%", marginRight: '10px' }}>Select Client</Label>
                <div style={{ width: '200px' }}> {/* Adjust width as needed */}
                  <Select
                    name="Client"
                    options={adminoption}
                    onChange={(option: any) => { handleClientChange(option); }}
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Select..."
                    value={ClientName ? { value: ClientId, label: ClientName } : null}
                  />
                </div>
              </div>
            </Col>
          )}
        </Row>
      </CardHeader>
      <CardBody className="transaction-card">
        <div className="table-responsive theme-scrollbar recent-wrapper">
          <Table className="display order-wrapper" id="recent-order">
            <thead >
              <tr>
                {isColVisible(columnOptions, savedColumns, 'ClientName') && <th>Client Name</th>}
                {isColVisible(columnOptions, savedColumns, 'PatientName') && <th>Patient Name</th>}
                {isColVisible(columnOptions, savedColumns, 'Payer') && <th>Payer</th>}
                {isColVisible(columnOptions, savedColumns, 'Date') && <th>Date</th>}
                {isColVisible(columnOptions, savedColumns, 'Errors') && <th>Errors</th>}
              </tr>
            </thead>
            <tbody >
              {recentOrdersBody.length > 0 ? (
                recentOrdersBody.map((data: any, index) => (
                  <tr key={index}>
                    {isColVisible(columnOptions, savedColumns, 'ClientName') && (
                      <td>
                        <div className="d-flex">
                          <div className="flex-grow-1 ms-2">
                            <H4>{data.ClientName}</H4>
                          </div>
                        </div>
                      </td>
                    )}
                    {isColVisible(columnOptions, savedColumns, 'PatientName') && (
                      <td>
                        <div className="d-flex">
                          <div className="flex-grow-1 ms-2">
                            <H4>{data.Patientname}</H4>
                          </div>
                        </div>
                      </td>
                    )}
                    {isColVisible(columnOptions, savedColumns, 'Payer') && <td >{data.Payer_name}</td>}
                    {isColVisible(columnOptions, savedColumns, 'Date') && <td>{data.uploaded_date}</td>}
                    {isColVisible(columnOptions, savedColumns, 'Errors') && <td className={`txt-danger`}>{data.error_message}</td>}
                  </tr>
                ))) : (
                <tr>
                  <td colSpan={visibleColCount(columnOptions, savedColumns)} style={{ textAlign: 'center' }}>
                    No records to display
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>

  );
};

export default RecentOrders;
